var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgZone } from '@angular/core';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { CommonConstant, CampaignInfluencerStatus } from '../../app.constants';
import { CacheService } from '../../services/cache/cache.service';
import { Location } from '@angular/common';
import { Influencer } from '../../../models/influencer';
import { EventTrackerService, UserActionType, Page, TargetType, ActivePages, ActionDetails, ActionSource } from '../../services/event-tracker/event-tracker.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { GroupDetailsComponent } from '../group-details/group-details.component';
import { GroupService } from '../../services/group-details/group.service';
import { ModalService } from '../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { CampaignInfluencerStatus as CampaignStatus } from '../../app.constants';
import { InfluencerSearch } from '../../../models/influencer-search';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { Observable } from 'rxjs/Observable';
import { EventFilterType, EventType, EventFilter } from '../../../models/user-notification';
import { StringUtils } from '../../utils/string.utils';
import { WebUtils } from '../../utils/web.utils';
var InfluencerListComponent = /** @class */ (function (_super) {
    __extends(InfluencerListComponent, _super);
    function InfluencerListComponent(groupService, userService, route, router, referenceDataService, location, campaignService, influencerGroupService, modalService, cacheService, placeholderVisibilityService, ngZone, eventTracker, influencerService, translate) {
        var _this = _super.call(this, groupService, userService, route, router, referenceDataService, location, campaignService, influencerGroupService, modalService, cacheService, placeholderVisibilityService, ngZone, eventTracker, influencerService, translate) || this;
        _this.userService = userService;
        _this.searchCriteria = new InfluencerSearch();
        _this.isLoadingData = false;
        _this.newAddedInfluencerList = [];
        _this.numberOfPostChange = 0;
        _this.campaignTotalPost = 0;
        _this.isArchivedCampaign = false;
        _this.periodRange = 7;
        return _this;
    }
    InfluencerListComponent.prototype.ngOnInit = function () {
        this.companyId = this.userService.getCompanyId();
        this.initializeSearchInfo();
        this.initializeData();
        this.loadGroupList();
        this.loadCampaignList();
        this.setupPlatformSettingSubscription();
    };
    InfluencerListComponent.prototype.ngOnDestroy = function () {
        this.cancelPendingRequest();
        this.destroyPlatformSettingSubscription();
    };
    InfluencerListComponent.prototype.initializeData = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.campaignId = params.selectedCampaign ? Number(params.selectedCampaign) : Number(_this.route.snapshot.params.id);
            _this.loadCampaignData(_this.campaignId, _this.companyId);
            _this.loadInfluencerList(_this.searchCriteria, true);
            _this.getCampaignInfluencerPostCount(_this.campaignId, _this.periodRange);
        });
    };
    InfluencerListComponent.prototype.initializeSearchInfo = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            Object.keys(params).forEach(function (key) {
                if (key === 'searchString') {
                    _this.openSearchBar = true;
                }
            });
            _this.searchCriteria = Object.assign({}, _this.searchCriteria);
            if (params.search) {
                _this.searchCriteria.searchString = params.search;
                _this._previousSearch = params.search;
            }
            _this.searchCriteria.orderBy = _this.searchCriteria.orderBy ? _this.searchCriteria.orderBy : CommonConstant.SORT_BY_REACH;
        });
    };
    InfluencerListComponent.prototype.loadCampaignData = function (campaignId, companyId) {
        var _this = this;
        // Get campaign details
        this.campaignService.getCampaign(campaignId, companyId).subscribe(function (data) {
            // process campaign data
            _this.campaignData = data.campaign;
            _this.campaignName = data.campaign.name;
            _this.isArchivedCampaign = data.campaign.status && data.campaign.status === CampaignStatus.ARCHIVED ? true : false;
        }, function (error) {
            if (error.status === 404) {
                _this.router.navigate(['campaigns'], { queryParams: { activeAccount: _this.companyId } });
            }
        });
    };
    InfluencerListComponent.prototype.loadInfluencerList = function (influencerSearch, isLoadMore, hasAddedNewInfluencer) {
        var _this = this;
        if (hasAddedNewInfluencer === void 0) { hasAddedNewInfluencer = false; }
        this.isLoadingData = true;
        // clear previous influencer list if it's not load more
        if (!isLoadMore) {
            this.influencerList = [];
        }
        this.placeholderVisibilityService.show(CommonConstant.INFLUENCER_LIST_PLACEHOLDER);
        var campaignInfluencerObservers = Observable.forkJoin([
            this.campaignService.searchCampaignInfluencers(influencerSearch, this.campaignId),
            this.userService.getNewEventFromLastTime(EventType.NEW_CAMPAIGN_POST, this.companyId, this.userService.lastViewedCampaignTime(), new EventFilter(EventFilterType.INFLUENCER_ID, this.campaignId))
        ]);
        this.campaignInfluencerSubscription = campaignInfluencerObservers.subscribe(function (_a) {
            var res = _a[0], newInflPostEvent = _a[1];
            _this.isLoadingData = false;
            if (hasAddedNewInfluencer) {
                // Update new add influencer
                var influencerArr_1 = res.filter(function (item) { return _this.newAddedInfluencerList.find(function (newAddedItem) { return item.influencerId === newAddedItem.influencer_id; }); });
                var newInfluencerList = _this.influencerList.map(function (influencerListItem) {
                    var influencerNeedToUpdate = influencerArr_1.find(function (influencerArrItem) { return influencerArrItem.influencerId === influencerListItem.influencer_id; });
                    if (influencerNeedToUpdate) {
                        return influencerListItem = _this.mapInfluencerCampaign(influencerNeedToUpdate, newInflPostEvent);
                    }
                    else {
                        return influencerListItem;
                    }
                });
                _this.influencerList = newInfluencerList;
            }
            else {
                _this.influencerList = res.map(function (item) { return _this.mapInfluencerCampaign(item, newInflPostEvent); });
            }
        }, function (_a) {
            var e1 = _a[0], e2 = _a[1];
            if (hasAddedNewInfluencer) {
                _this.isLoadingData = false;
                var failedInfluncerArr = _this.influencerList.map(function (ifItem) {
                    if (ifItem.isNewAdded) {
                        ifItem.isFailedUpdate = true;
                        return ifItem;
                    }
                    return ifItem;
                });
                _this.influencerList = failedInfluncerArr;
                _this.closePopup();
                _this.errorMessage = _this.translate.instant('campaigns.campaign_influencer_detail.fecth_kpi_fail');
                _this.modalService.open(_this.influencerListError, function () {
                    _this.errorMessage = null;
                }, true);
            }
            else {
                _this.handleSearchError(e1);
            }
        });
    };
    InfluencerListComponent.prototype.handleSearchError = function (error) {
        var _this = this;
        this.closePopup();
        var isLoadingCase = StringUtils.isUndefinedNullOrEmpty(this.searchCriteria.searchString);
        if (isLoadingCase) {
            WebUtils.reportErrorToSentry('Campaign Details failed to load influencers.', error);
            this.errorMessage = this.translate.instant('campaigns.campaign_influencer_detail.api_load_fail');
            this.modalService.open(this.influencerListError, function () {
                _this.errorMessage = null;
            }, true);
            return;
        }
        // search case
        WebUtils.reportErrorToSentry('Campaign Details search failed.', error);
        this.modalService.openInCenter(this._searchErrorDialog);
    };
    InfluencerListComponent.prototype.closePopup = function () {
        this.modalService.close();
    };
    InfluencerListComponent.prototype.onRetrySeacrh = function () {
        this.closePopup();
        this.searchInfluencerByText(this.searchCriteria.searchString);
    };
    InfluencerListComponent.prototype.getCampaignInfluencerPostCount = function (campaignId, periodRange) {
        var _this = this;
        this.campaignService.getCampaignInfluencerPostCount(campaignId, periodRange).subscribe(function (res) {
            if (res) {
                _this.campaignTotalPost = res.value;
                _this.numberOfPostChange = res.change;
            }
        });
    };
    InfluencerListComponent.prototype.back = function () {
        if (!this.isArchivedCampaign) {
            var queryParams = { activeAccount: this.companyId };
            if (!StringUtils.isUndefinedNullOrEmpty(this._previousSearch)) {
                queryParams.search = this._previousSearch;
            }
            return this.router.navigate(['campaigns'], { queryParams: queryParams });
        }
        return this.location.back();
    };
    InfluencerListComponent.prototype.mapInfluencerCampaign = function (influencer, newInfluencerPostEvent) {
        var influencerCamp = new Influencer();
        influencerCamp.country = influencer.country;
        influencerCamp.influencer_id = influencer.influencerId;
        influencerCamp.influencer_name = influencer.influencerName;
        influencerCamp.profilePicture = influencer.profileImage;
        influencerCamp.influencer_image = influencer.profileImage;
        influencerCamp.country_code = influencer.country.code;
        influencerCamp.engagement = influencer.engagement;
        influencerCamp.impact = influencer.impact * 100;
        influencerCamp.reach = influencer.reach;
        influencerCamp.numberOfPosts = influencer.totalPost;
        influencerCamp.numberOfFollowers = influencer.follower;
        influencerCamp.platform = influencer.platformIds ? this.convertPlatformIdToName(influencer.platformIds) : null;
        influencerCamp.campaign_influencer_id = influencer.campaignInfluencerId;
        influencerCamp.influencerStatus = influencer.status;
        var newPosts = newInfluencerPostEvent ? newInfluencerPostEvent.events.find(function (evt) { return evt.key === String(influencer.influencerId); }) : null;
        if (newPosts) {
            influencerCamp.newPosts = newPosts.value;
        }
        return influencerCamp;
    };
    InfluencerListComponent.prototype.convertPlatformIdToName = function (platformIdArray) {
        var platformArr = [];
        if (platformIdArray.length === 0) {
            return;
        }
        this.platformList.map(function (item) {
            platformIdArray.map(function (platformId) {
                if (platformId === item.id) {
                    platformArr.push(item.name);
                }
            });
        });
        return platformArr.toString();
    };
    InfluencerListComponent.prototype.advanceSearchInfluencerList = function (influencerSearch) {
        this.searchCriteria = Object.assign({}, this.searchCriteria, influencerSearch);
        this.searchCriteria.scrollId = undefined;
        this.fetchInfluencerListOfCampaign();
    };
    InfluencerListComponent.prototype.fetchInfluencerListOfCampaign = function (isLoadMore) {
        if (isLoadMore === void 0) { isLoadMore = false; }
        // cancel previous request
        this.cancelPendingRequest();
        // perform search
        this.loadInfluencerList(this.searchCriteria, isLoadMore);
    };
    InfluencerListComponent.prototype.cancelPendingRequest = function () {
        if (this.campaignInfluencerSubscription) {
            this.campaignInfluencerSubscription.unsubscribe();
        }
        this.placeholderVisibilityService.hideImmediately(CommonConstant.GROUP_DETAILS_PLACEHOLDER);
    };
    InfluencerListComponent.prototype.openCampaignDetails = function (campaignId) {
        this.cacheService.disableCacheRemoving();
        return this.router.navigate(['campaigns', campaignId], {
            queryParams: {
                activeAccount: this.activeAccount,
                isCampaignInfluencer: true
            }
        });
    };
    InfluencerListComponent.prototype.loadCampaignList = function () {
        var _this = this;
        this.campaignService.getCampaignShortListForCompany(this.companyId).subscribe(function (res) {
            _this.campaignList = res.filter(function (campaignItem) { return campaignItem.status !== CampaignInfluencerStatus.ARCHIVED; }).map(function (campaign) { return ({
                id: campaign.id,
                name: campaign.name,
                brief: campaign.brief
            }); });
        });
    };
    InfluencerListComponent.prototype.loadGroupList = function () {
        var _this = this;
        this.influencerGroupService.getInfluencerGroupShortList(this.companyId).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name,
                description: group.description
            }); });
        });
    };
    InfluencerListComponent.prototype.selectAllInfluencer = function (e) {
        if (e) {
            this.influencerList.filter(function (infl) { return !infl.isPending; }).forEach(function (influencer) {
                influencer.selected = true;
            });
            _super.prototype.showNotificationSelectAll.call(this);
        }
        else {
            this.influencerList.filter(function (infl) { return !infl.isPending; }).forEach(function (influencer) {
                influencer.selected = false;
            });
            _super.prototype.closeNotificationSelectAll.call(this);
        }
    };
    InfluencerListComponent.prototype.onSelectSingleInfluencer = function (selectedInfluencer) {
        this.influencerList.forEach(function (influencer) {
            if (influencer.influencer_id === selectedInfluencer.influencer_id) {
                influencer.selected = !influencer.selected;
            }
        });
        if (selectedInfluencer.selected === true) {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN_DETAILS, {
                id: selectedInfluencer.influencer_id,
                name: selectedInfluencer.influencer_name,
                type: TargetType.INFLUENCER
            }, {
                action: UserActionType.SELECTION
            }, undefined, null, null);
        }
    };
    InfluencerListComponent.prototype.addInfluencerToCurrentCampaign = function (data) {
        this.isLoadingData = true;
        this.pendingInfluencerToAdd = data;
        var filteredNewAcceptInfluencer = [];
        filteredNewAcceptInfluencer = data.filter(function (item) { return item.is_accepted; });
        this.newAddedInfluencerList = this.campaignService.mapNewAddedInfluencer(data, filteredNewAcceptInfluencer);
        if (filteredNewAcceptInfluencer && filteredNewAcceptInfluencer.length === 0) {
            this.influencerList = this.influencerList.concat(this.newAddedInfluencerList);
            this.isLoadingData = false;
            var newList = this.influencerList.map(function (item) {
                if (item.isNewAdded) {
                    item.isNewAdded = false;
                }
                return item;
            });
            this.influencerList = newList;
        }
        else {
            this.influencerList = this.influencerList.concat(this.newAddedInfluencerList);
        }
    };
    InfluencerListComponent.prototype.addInfluencerToCampaignError = function () {
        var pendingInfluencerIds = this.pendingInfluencerToAdd.map(function (infl) { return infl.influencer_id; });
        this.influencerList = this.influencerList.filter(function (infl) {
            return pendingInfluencerIds.indexOf(infl.influencer_id) < 0 && infl.influencerStatus !== CampaignInfluencerStatus.NEW.toLowerCase();
        });
    };
    InfluencerListComponent.prototype.addInfluencerAsAcceptedSuccess = function () {
        this.loadInfluencerList(this.searchCriteria, true, true);
    };
    InfluencerListComponent.prototype.deleteInfluencerFromBottomBar = function (evt) {
        this.deleteInfluencers = evt.influencerToDelete;
        var influencerToDeleteIds = this.deleteInfluencers.map(function (inf) { return inf.influencer_id; });
        this.deleteCampaignInfluencers(influencerToDeleteIds);
    };
    InfluencerListComponent.prototype.deleteCampaignInfluencers = function (influencerToDeleteIds) {
        var _this = this;
        // keep removed indexs and remove influencer on UI immediately
        var deletedInfluencerIndexMap = new Map();
        var influencerToDelete = this.influencerList.filter(function (item) { return influencerToDeleteIds.find(function (idItem) { return idItem === item.influencer_id; }); });
        this.deleteInfluencers.forEach(function (di) {
            var removingIndex = _this.influencerList.findIndex(function (inf) { return inf.influencer_id === di.influencer_id; });
            deletedInfluencerIndexMap.set(di.influencer_id, removingIndex);
            _this.influencerList.splice(removingIndex, 1);
        });
        this.deleteInfluencerFromCampaign(influencerToDelete, influencerToDeleteIds, deletedInfluencerIndexMap);
    };
    InfluencerListComponent.prototype.deleteInfluencerFromCampaign = function (influencerToDelete, influencerToDeleteIds, deletedInfluencerIndexMap) {
        var _this = this;
        if (influencerToDelete && influencerToDelete.length > 0) {
            influencerToDelete.map(function (influencerItemToDelete) {
                _this.campaignService.deleteInfluencerFromCampaign(influencerItemToDelete.campaign_influencer_id).subscribe(function (res) {
                    _this.modalService.close();
                    _this.deleteInfluencers = [];
                    _this.totalInfluencer = _this.totalInfluencer - influencerToDeleteIds.length;
                    _this.closeBottonBar(true);
                    _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
                        id: influencerItemToDelete.influencer_id,
                        name: influencerItemToDelete.influencer_name,
                        type: TargetType.INFLUENCER_GROUP
                    }, {
                        action: UserActionType.UPDATE,
                        actionDetails: ActionDetails.REMOVED_INFLUENCERS,
                        source: ActionSource.BOTTOM_BAR
                    }, undefined, { type: ActivePages.CAMPAIGN_DETAILS });
                    _this.userService.triggerUpdateActivatedInfluencers();
                }, function (error) {
                    _this.deleteInfluencers.forEach(function (di) {
                        _this.influencerList.splice(deletedInfluencerIndexMap.get(di.id), 0, di);
                    });
                    // show error message
                    _this.errorMessage = _this.translate.instant('group_details.influencer.delete_influencer_error');
                    _this.modalService.open(_this.influencerListError, function () {
                        _this.errorMessage = null;
                    }, true);
                });
            });
        }
    };
    return InfluencerListComponent;
}(GroupDetailsComponent));
export { InfluencerListComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-list/influencer-list.component.ts.pre-build-optimizer.js